import { HttpHeaders } from "@angular/common/http";

export function getHttpHeader(authorization: string, tenantCode: string): { headers: HttpHeaders }{
  return { 
    headers: new HttpHeaders({ 
      tenantCode, 
      appId: 'none', 
      authorization,
      'Content-Type': 'application/json'
    })
  };
}
